import React, { useState } from 'react';
import "../assets/css/proposal.css";
import { Tab, Nav } from "react-bootstrap";
import { useEffect } from 'react';
import { centralCall } from '../api';
import { useSharedDataContext } from './SharedDataContext';
import 'antd/dist/reset.css';
import { useHistory } from 'react-router-dom';
import AddonSummaryCard from './ChildComp/AddonSummaryCard';
import Loader from './ChildComp/Loader';
import Popup from './ChildComp/CkycPopup';
import { splitAddress } from './utility/utilityFunction';
import ProposerDetailsForm from './ChildComp/ProposerDetailsForm';
import PetDetailsForm from './ChildComp/PetDetailsForm';
import MedicalHistoryForm from './ChildComp/MedicalHistoryForm';

const ProposalForm = (props) => {

    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { sharedData, setSharedData } = useSharedDataContext();

    const [PastDogInsuredExperience, setPastDogInsuredExperience] = useState("");
    const [PreviousClaimExperience, setPreviousClaimExperience] = useState("");
    const [IsAddress3, setIsAddress3] = useState("");
    const [IsPincode, setIsPincode] = useState(sharedData.pincode);
    const [IsCity, setIsCity] = useState(sharedData.cityName);
    const [IsState, setIsState] = useState(sharedData.stateName);
    const [OwnerDetails, setOwnerDetails] = useState(true);
    const [ckycNo, setckycNo] = useState("");
    const [ckycapicall, setckycapicall] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ckycUrl, setckycUrl] = useState("");
    /*pet Details*/
    const [PetDetails, setPetDetails] = useState(false);
    /*pet Detail Ends*/
    const [DisabledTab2, setDisabledTab2] = useState(true);
    const [DisabledTab3, setDisabledTab3] = useState(true);
    const [ErrorMSG, setErrorMSG] = useState({});
    const [BtnVal, setBtnVal] = useState("Save & Continue to Pet Details");
    const [activeTabKey, setActiveTabKey] = useState("link-1");
    const [documentFile, setdocumentFile] = useState(null);
    const [CKYCproposalID, setCKYCproposalID] = useState("");
    const [IsRedirectUrl, setIsRedirectUrl] = useState(false);
    const [ownerDetailsObj, setOwnerDetailsObj] = useState({});
    const [petDetailsObj, setPetDetailsObj] = useState({});
    const [medicalDetailsObj, setMedicalDetailsObj] = useState({});
    const [completedTab, setCompletedTab] = useState([1]);


    useEffect(() => {
        setIsState(sharedData.stateName);
        setIsCity(sharedData.cityName);
    }, [sharedData.cityName, sharedData.stateName]);


    const checkCKYC = async ({ EnquiryNo, InsurerID, DocNumber, ownerData }) => {
        console.log({ ownerDetailsObj });
        const payload = {
            EnquiryNo,
            InsurerID,
            DocType: "pan",
            DocNumber,
            IsRedirectUrl,
            CKYCRefID: CKYCproposalID,
            UniqueID: CKYCproposalID,
            Name: ownerDetailsObj.FullName ? ownerDetailsObj.FullName : ownerData.OwnerName,
            DOB: ownerDetailsObj.DOB ? ownerDetailsObj.DOB?.split("-").reverse().join("-") : ownerData.DOB?.split("-").reverse().join("-"),
            Gender: ownerDetailsObj.ProposerGender ? ownerDetailsObj.ProposerGender : ownerData.ProposerGender,
            MobileNo: ownerDetailsObj.MobileNo ? ownerDetailsObj.MobileNo : ownerData.MobileNo,
            EmailID: ownerDetailsObj.EmailID ? ownerDetailsObj.EmailID : ownerData.EmailID,
            ProductType: 4
        }
        return await centralCall({ URL: "/CheckCkycStatus", Request: payload, IsPost: true });
    }

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const callCKYCApi = (data) => {
        setIsLoading(true);
        setckycNo("");
        setckycUrl("");
        setIsModalOpen(false);
        setCKYCproposalID("");
        checkCKYC({ EnquiryNo: sharedData.enquiryno, InsurerID: 108, DocNumber: data.PanNumber , ownerData:data})
            .then(res => {

                setckycapicall(false);
                setIsLoading(false);
                setBtnVal("Save & Continue to Pet Details");
                switch (res.data.StatusCode) {
                    case 200:
                        const kycResponse = res.data?.Response;
                        setckycNo(res.data.Response.CKYCID);
                        setDisabledTab2(false);
                        setOwnerDetails(true);
                        setPetDetails(true);
                        setIsRedirectUrl(false);
                        handleTabChange("link-2");
                        setCompletedTab([...completedTab, 2]);
                        setIsPincode(kycResponse.PinCode);
                        if (kycResponse.PinCode) {
                            bindCityStateNameByPin(kycResponse?.PinCode)
                        }
                        
                        setSharedData(prev => ({
                            ...prev, ownername: kycResponse.Name, pincode: kycResponse.PinCode, ownerDetailsObj: { ...prev.ownerDetailsObj, EmailID: data.EmailID, MobileNo: data.MobileNo, ProposerGender: kycResponse.Gender, OwnerName: kycResponse.Name, DOB: kycResponse.DOB?.split("-").reverse().join("-"), PanNumber: kycResponse.DocNumber, Pincode: kycResponse.PinCode, Address1: splitAddress(kycResponse.AddressLine1)?.address1, Address2: splitAddress(kycResponse.AddressLine1)?.address2, Address3: IsAddress3 }
                        }));
                        setOwnerDetailsObj(prev => ({ ...prev, EmailID: data.EmailID, MobileNo: data.MobileNo, ProposerGender: kycResponse.Gender, OwnerName: kycResponse.Name, DOB: kycResponse.DOB?.split("-").reverse().join("-"), PanNumber: kycResponse.DocNumber, Pincode: kycResponse.PinCode, Address1: splitAddress(kycResponse.AddressLine1)?.address1, Address2: splitAddress(kycResponse.AddressLine1)?.address2, Address3: IsAddress3 }))
                        
                        break;
                    case 480:
                         const newWindow = window.open('', '_blank');
                        if (res.data.Response.RedirectLink) {
                            setCKYCproposalID(res.data?.Response?.CKYCRefID)
                             //window.open(res.data.Response.RedirectLink, "_blank");
                           newWindow.location.href = res.data.Response.RedirectLink;

                            setIsRedirectUrl(true);
                        } else {
                            setIsRedirectUrl(false);
                            newWindow.close();
                        }
                        break;
                    default: console.log("Something went wrong");
                        break;
                }

            }).catch(err => {
                console.log(err.message);
                setckycapicall(false);
                setIsLoading(false);
                setBtnVal("Save & Continue to Pet Details")
            })
    }


    const handleRetryckyc = () => {
        setIsModalOpen(false);
    }



    const handleTabChange = (key) => {
        setActiveTabKey(key);
    };
    const GotoSummary = () => {
        history.push({
            pathname: "/summary",
            state: {
                sharedData: sharedData
            }
        });
    };

    const constructProposalModel = (medicalData) => {

        const petDetails = {
            "BreedCategory": sharedData.breedCategory,
            "Breed": petDetailsObj.PetBreed,
            "Age": (parseInt(petDetailsObj.PetAge.split(' ')[0]) * 12 + parseInt(petDetailsObj?.PetAgeMonth?.split(' ').length > 1 ? petDetailsObj?.PetAgeMonth?.split(' ')[0] : 0)),
            "Gender": petDetailsObj.PetGender,
            "Weight": petDetailsObj.PetWeight,
            "SumInsured": sharedData.SumInsured,
            AddonsSelected: {
                ...sharedData.AddonsSelected,
                EmergencyPetMindingCoverDays: sharedData.EmergencyPetMindingCoverDays,
                VeteneryConsultationOrDoctorOnCallCoverDays: sharedData.VeteneryConsultationOrDoctorOnCallCoverDays,
                VeteneryConsultationOrDoctorOnCallCoverAmount: sharedData.VeteneryConsultationOrDoctorOnCallCoverAmount,
            },
            "PetName": petDetailsObj.PetName,
            "Identification": petDetailsObj.PetIMark,
            "Features": "",
            "TagNo": petDetailsObj.TagNo,
            "IsPetIll": (medicalDetailsObj.IsHealthy ? medicalDetailsObj.IsHealthy : medicalData.IsHealthy) === "Y" ? false : true,
            "PetIllnessDetails": medicalDetailsObj.IsHealthy ? (medicalDetailsObj.IsHealthy === "Y" ? "" : medicalDetailsObj.PetIllnessDetails) : (medicalData.IsHealthy === "Y" ? "" : medicalData.PetIllnessDetails),
            "AnyPreExistingDisese": (medicalDetailsObj.Ped ? medicalDetailsObj.Ped : medicalData.Ped) === "Y" ? true : false,
            "PreExistingDiseases": medicalDetailsObj.Ped ? (medicalDetailsObj.Ped === "Y" ? medicalDetailsObj.PreExistingDiseases : "") : (medicalData.Ped === "Y" ? medicalData.PreExistingDiseases : ""),
            "Vaccinations": medicalDetailsObj.selectedVaccinations ? medicalDetailsObj.selectedVaccinations : medicalData.selectedVaccinations,
            "HasCommercialUse": petDetailsObj.IsCommercial === "Y" ? true : false,
            "CommercialUseDetails": petDetailsObj.IsCommercial === "Y" ? petDetailsObj.CommercialUseDetails : "",
            "HasOtherInsurance": petDetailsObj.IsdogInsured === "Y" ? true : false,
            "OtherInsurancePolicyNo": petDetailsObj.IsdogInsured === "Y" ? petDetailsObj.OtherInsurancePolicyNo : "",
            "OtherInsurerName": petDetailsObj.IsdogInsured === "Y" ? petDetailsObj.OtherInsurerName : "",
            "OwnAnotherDog": medicalDetailsObj.OwnAnotherDog ? medicalDetailsObj.OwnAnotherDog : medicalData.OwnAnotherDog,
            "LostAnyPet": medicalDetailsObj.LostAnyPet ? medicalDetailsObj.LostAnyPet : medicalData.LostAnyPet,
            "PastDogInsuredExperience": PastDogInsuredExperience,
            "PreviousClaimExperience": PreviousClaimExperience
        };
        return {
            "MobileNo": ownerDetailsObj.MobileNo,
            "LeadSource": "pet",
            "ClientId": 0,
            "UserId": 0,
            "EnquiryNo": sharedData.enquiryno,
            "ProposerName": ownerDetailsObj.OwnerName,
            "EmailId": ownerDetailsObj.EmailID,
            "Address1": ownerDetailsObj.Address1,
            "Address2": ownerDetailsObj.Address2,
            "Address3": ownerDetailsObj.Address3,
            "City": ownerDetailsObj.City,
            "StateCode": ownerDetailsObj.State,
            "PinCode": ownerDetailsObj.Pincode,
            "DoB": ownerDetailsObj.DOB,
            "Gender": ownerDetailsObj.ProposerGender,
            "PanNo": ownerDetailsObj.PanNumber,
            "PetDetails": [petDetails]
        };
    };

    const bindCityStateNameByPin = (pincode) => {
        if (pincode?.length === 6) {
            centralCall({ URL: `/api/Binding/GetStateCityListByPincode?pincode=${pincode}` }).then(res => {
                if (res.data.StatusCode == "200") {
                    const data = res.data.Data[0];
                    setSharedData(prev=>({ ...prev, stateName: data.State, cityName: data.City }));
                    if (data) { setErrorMSG({ ...ErrorMSG, IsPincode: "" }); }
                }
            });
        } else {
            setSharedData(prev=>({ ...prev, stateName: "", cityName: "" }));
        }
    }

    const getOwnerDetailsObj = (data) => {
        setOwnerDetailsObj(data);
        callCKYCApi(data);
    }

    const getPetDetailsObj = (data) => {
        setPetDetailsObj(data);
        setDisabledTab3(false);
        handleTabChange("link-3");
        setCompletedTab([...completedTab, 3]);
    }

    const callFinalProposal = (medicalData) => {
        try {
            setMedicalDetailsObj(medicalData);
            setIsLoading(true);
            const proposalmodel = constructProposalModel(medicalData);

                const formData = new FormData();
                formData.append('ProposalRequest', JSON.stringify(proposalmodel));
                if (documentFile) {
                    formData.append('Document', petDetailsObj.DocumentFile ?? null);
                } else {
                    formData.append('Document',  null);
                }


                petDetailsObj.PetImages.forEach((obj, ind) => {
                    formData.append(`photo${ind === 0 ? "" : ind + 1}`, obj.image);
                })
                formData.append('photo4', null);
                //fetchProposal(formData)
                centralCall({ URL: '/api/Quotation/GetProposal', Request: formData, IsPost: true, ContentType: 'multipart/form-data' })
                    .then(res => {
                        setSharedData(prevData => ({
                            ...prevData,
                            proposalmodel: proposalmodel,
                        }));
                        const data = res.data;
                        if (data.StatusCode === "200") {
                            setSharedData(prevData => ({
                                ...prevData,
                                proposalmodel: proposalmodel,
                                TotalPremium: data.Data.TotalPremium,
                                GST: data.Data.GST,
                                Premium: data.Data.Premium,
                                QuoteId: data.Data.QuoteId,
                                ProposalNo: data.Data.WinNo,
                                ClientId: data.Data.ClientId,
                                ProposalMessage: data.Data.QuoteMessage,
                                ReceiptNo: data.Data.ReceiptNo,
                            }));

                            GotoSummary();

                        }
                        setTimeout(() => { setIsLoading(false); }, 1000);

                    })
            } catch (error) {
                setTimeout(() => { setIsLoading(false); }, 1000);
                console.error('Error fetching data:', error);
            }
    }

    return (


        <div className="Proposal">
            {ckycUrl && (<Popup isOpen={isModalOpen} closeModal={closeModal} onRetry={handleRetryckyc} url={ckycUrl} />)}
            <div>
                {isLoading && (<Loader />)}
            </div>
            {(
                <div className="container">
                    <div className="BackBTNRow">
                        <a className="arw-btn d-flex align-items-center" onClick={() => history.goBack()}>
                            {/*<i className="fas fa-long-arrow-alt-left mx-1"></i>*/}
                            <i className="fas fa-chevron-left mx-1"></i>
                            <span>Back to Quotations</span>
                        </a>
                    </div>

                    <div className="row PropsalPlace">
                        <div className="col-md-9">
                            <Tab.Container activeKey={activeTabKey} onSelect={handleTabChange}>
                                <div className="HealthProUpdFormTabLink">
                                    <Nav variant="pills">
                                        <Nav.Item>
                                            <Nav.Link eventKey="link-1" className={activeTabKey == "link-1" ? "completed" : "incomplete"}>
                                                <i className={(activeTabKey == "link-2" || activeTabKey == "link-3") ? "FillFormFix rightIcon" : "FillFormFix wrongIcon"}></i>
                                                <span className={completedTab.includes(1) ? "ActiveDone" : ""}> Owner<br /> Details</span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="link-2" disabled={DisabledTab2} className={activeTabKey == "link-2" ? "completed" : "incomplete"}>
                                                <i className={activeTabKey == "link-3" ? "FillFormFix rightIcon" : "FillFormFix wrongIcon"}></i>
                                                <span className={completedTab.includes(2) ? "ActiveDone" : ""}> Pet <br /> Details</span>

                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="link-3" disabled={DisabledTab3} className="incomplete">
                                                <i className="FillFormFix wrongIcon"></i>
                                                <span className={completedTab.includes(3) ? "ActiveDone" : ""}> Medical <br /> History</span>

                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <div className="ProposalTabsRight HealthProUpdFormBox">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="link-1">
                                            <h1> <span><img src={require('../../src/assets/images/user.svg').default} /></span> Owner Details</h1>
                                            {OwnerDetails && <ProposerDetailsForm getOwnerDetailsObj={getOwnerDetailsObj} BtnVal={BtnVal}/>}
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="link-2">
                                            <h1> <span><img src={require('../../src/assets/images/dog.svg').default} /></span> Pet Details</h1>
                                            {PetDetails && <PetDetailsForm getPetDetailsObj={getPetDetailsObj} />}
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="link-3">
                                            <h1> <span><img src={require('../../src/assets/images/medicalIcon.svg').default} /></span> Medical History</h1>
                                            <MedicalHistoryForm callFinalProposal={callFinalProposal} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </Tab.Container>
                        </div>
                        <div className="col-md-3">
                            <AddonSummaryCard />
                            <div>
                                <img src={require('../../src/assets/images/Group 2913.svg').default} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
}
export default ProposalForm;
